export default __webpack_public_path__ + "232aa69cb7197b3a59c22d3945a8a675.png";